export default "__VITE_ASSET__DXIWerVC__"